import { render } from "./Technology.vue?vue&type=template&id=1f5f94da&scoped=true"
import script from "./Technology.vue?vue&type=script&lang=js"
export * from "./Technology.vue?vue&type=script&lang=js"

import "./Technology.vue?vue&type=style&index=0&id=1f5f94da&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5f94da"]])

export default __exports__